define([
   	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def",
	"csi/def/Field",
	"csi/state/rootStore",
	"./NewFromTestRun"
], function(array,declare,lang,def,Field,{ routerStore },NewFromTestRun) {

	return declare(NewFromTestRun, {
	    /**
	     * @override
	     * Add type node hint
	     */
	    _getFormView: function(node, bCheckOnly) {
	        this.m_action.m_typeNodeHint="TestRun";
	        return this.inherited(arguments);
	    },

		/**
		 * @override
		 * Product is actually higher up because this is from Sample
		 */
		onCreatePopupParams: function(params) {
		    params = params || {};
		    params.testRunContextNode = routerStore.getBreadcrumbNode("Style") || routerStore.getBreadcrumbNode("Material");
		    params.bCanCreateMultipleTestRuns = true;
		},

		storeSources: function() {
			// summary: convert selected CDoc to be a selected TestRun template
			this.inherited(arguments);
			this.m_aSources = array.map(this.m_aSources, function(cDoc) {
				return this.m_cache.getPathNode(cDoc, "Child:CurrentRevision/Child:SourceObjectRevision/Child:__Parent__", true);
			}, this);
		}
	});
});